import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { mdiSparkles } from '@lumapps/lumx/icons';
import { Icon, Link, List, ListItem } from '@lumapps/lumx/react';

export interface AskAiSuggestedQuestionsProps {
    className?: string;
    suggestionQuestions: string[];
    onSelect: (question: string) => void;
}

export const CLASSNAME = 'ask-ai-suggested-questions';

/**
 * Displays suggestions of follow up questions to ask the AI.
 */
export const AskAiSuggestedQuestions: React.FC<AskAiSuggestedQuestionsProps> = ({
    className,
    suggestionQuestions,
    onSelect,
}) => {
    const { block } = useClassnames(CLASSNAME);

    if (!suggestionQuestions || suggestionQuestions?.length === 0) {
        return null;
    }

    return (
        <List className={block([className])}>
            {suggestionQuestions.slice(0, 3).map((question) => (
                <ListItem key={question} size="tiny">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <Link color="primary" key={question} onClick={() => onSelect(question)}>
                        <Icon icon={mdiSparkles} size="xs" />
                        {question}
                    </Link>
                </ListItem>
            ))}
        </List>
    );
};
